import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ScenarioData from "./scenarioData";
import DataTableCellActions from "examples/Tables/DataTable2/DataTableCellActions";

import {
  activateScenario,
  deactivateScenario,
  deleteScenario,
    tmpxScenario,
} from "./scenarioApi";


const ScenarioOverviewTable = () => {
  const { t } = useTranslation();
  const [actionLoadingId, setActionLoadingId] = useState(null);
    //console.log(userId);
    const { data, loading, error,refetch  } = ScenarioData();

    // Define the table headers
    const columns = [
      { Header: t("scenarios.library.columns.id"), accessor: "id", width: "5%" },
      { Header: t("scenarios.library.columns.name"), accessor: "name", width: "10%" },
      { Header: t("scenarios.library.columns.category"), accessor: "category" , width: "10%"},
      { Header: t("scenarios.library.columns.from"), accessor: "start_date" , width: "10%"},
      { Header: t("scenarios.library.columns.until"), accessor: "end_date" , width: "10%"},
      { Header: t("scenarios.library.columns.status"), accessor: "status" , width: "10%"},
      { Header: t("scenarios.library.columns.target"), accessor: "target" , width: "10%"},

      { Header: "TMPx  ", accessor: "TMPx", width: "5%"},

       { Header: t("scenarios.library.columns.createdAt"), accessor: "created_at" , width: "10%"},
       { Header: t("scenarios.library.columns.createdBy"), accessor: "created_by" , width: "10%"},
       { Header: t("scenarios.library.columns.resultReference"), accessor: "result_reference" , width: "10%"},
      {
      Header: "",
      accessor: "actions",
      align: "right",
      width: 60,
      disableSortBy: true,
      Cell: ({ row }) => (
      <DataTableCellActions
        status={row.original.status}   
         loading={actionLoadingId === row.original.id}          
        onActivate={() => handleActivate(row.original)}
        onDeactivate={() => handleDeactivate(row.original)}
        onDelete={() => handleDelete(row.original)}
        onTmpx={() => handleTmpx(row.original)}
        iconColor="#fff"
      />
      ),
      }
    ];
  
const handleActivate = async (row) => {
  try {
    setActionLoadingId(row.id);
    await activateScenario(row.id);
    await refetch();
  } catch (e) {
    console.error(e);
  } finally {
    setActionLoadingId(null);
  }
};

const handleDeactivate = async (row) => {
  try {
    setActionLoadingId(row.id);
    await deactivateScenario(row.id);
    await refetch();
  } catch (e) {
    console.error(e);
  } finally {
    setActionLoadingId(null);
  }
};

const handleDelete = async (row) => {
  try {
    setActionLoadingId(row.id);
    await deleteScenario(row.id);
    await refetch();
  } catch (e) {
    console.error(e);
  } finally {
    setActionLoadingId(null);
  }
};
const handleTmpx = async (row) => {
  try {
    setActionLoadingId(row.id);
    await tmpxScenario(row.id);
    await refetch();
  } catch (e) {
    console.error(e);
  } finally {
    setActionLoadingId(null);
  }
};
const formatDateTime = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (isNaN(date)) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

    let showData = [];

    showData = data;
    
    const rows = showData.map((item, index) => ({
      id: item.id ?? "-",
      description: item.description ?? "-",
      category: item.category ?? "-",
      created_at: formatDateTime(item.created_at),
      start_date: formatDateTime(item.start_date),
      end_date: formatDateTime(item.end_date),
      TMPx: item.TMPx ?? "-",
      name: item.name ?? "-",
      status: item.status ?? "-",
      target: item.target ?? "-",
      created_by: item.created_by ?? "-",
      result_reference: item.result_reference ?? "-",
      _raw: item,
    }));
  
    // Return the table-ready data
    return {
      tableData: { columns, rows },
      loading,
      error,
    };
  };
  
  export default ScenarioOverviewTable;
